import React, { Component } from "react";
import "../LandingPage/LandingPageStyleSheet.css";
import { loadLocalUser } from "../Services/HWIframeBridge";

class NewConversation extends Component {
  render() {
    return (
      <div style={{ width: "98%", marginTop: "9px", marginLeft: "15px" }}>
        <div
          className="s360-new-conversation-tab"
          style={this.newConversationStyle()}
        >
          <button
            className="s360-new-conversation-tab-text"
            style={this.newConversationTextStyle()}
            onClick={this.startConversation}
          >
            Hello start a new conversation here..
          </button>
        </div>
        <div className="s360-new-conversation-tab-image">
          {this.attachmentSVGImage(
            this.props.config.designDetails.selectionButtonsvgColor,
            this.props.config.designDetails.selectionButtonsvgWidth,
            this.props.config.designDetails.selectionButtonsvgHeight
          )}
          {/* <img style={{ width: "38px", height: "38px", marginRight: "8px", marginLeft: "8px", cursor: "pointer",marginBottom:"30px" }} src={sendMsgImage}  alt="/"></img> */}
        </div>
      </div>
    );
  }

  attachmentSVGImage = (imageColor, width, height) => {
    // return <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
    //     width={width || "100%"} height={height || "100%"}
    //     viewBox="0 0 172 172"
    //     style={{ fill: imageColor }}><g fill="none" fillRule="nonzero" stroke="none" strokeWidth="1" strokeLinecap="butt" strokeLinejoin="miter" strokeMiterlimit="10" strokeDasharray="" strokeDashoffset="0" fontFamily="none" fontWeight="none" fontSize="none" textAnchor="none" style={{ mixBlendMode: "normal" }}><path d="M0,172v-172h172v172z" fill="none"></path><g fill={imageColor}><path d="M86,14.33333c-39.5815,0 -71.66667,32.08517 -71.66667,71.66667c0,39.5815 32.08517,71.66667 71.66667,71.66667c39.5815,0 71.66667,-32.08517 71.66667,-71.66667c0,-39.5815 -32.08517,-71.66667 -71.66667,-71.66667zM121.83333,93.16667h-28.66667v28.66667h-14.33333v-28.66667h-28.66667v-14.33333h28.66667v-28.66667h14.33333v28.66667h28.66667z"></path></g></g></svg>

    //  return <svg focusable="false" aria-hidden="true" x="0px" y="0px" viewBox="0 0 15 16" width={width || "100%"} height={height || "100%"} style={{ fill: imageColor }} ><g transform="translate(-24.000000, -12.000000)"><path d="M25.4036262,27.3409362 C24.4176893,27.8509036 23.8195834,27.3951055 24.0683403,26.3201996 L25.0887779,21.910776 C25.2131242,21.3734618 25.7510472,20.8884231 26.3078778,20.8254187 L32.503417,20.1244045 C34.151155,19.9379658 34.1569707,19.6389088 32.503417,19.4549971 L26.3078778,18.7659164 C25.7589338,18.7048617 25.2129433,18.217839 25.0887779,17.6798715 L24.0683403,13.2586546 C23.8198614,12.1820783 24.408944,11.7182276 25.4036262,12.2327184 L38.22304,18.8634497 C39.208977,19.373417 39.2177223,20.1957141 38.22304,20.7102049 L25.4036262,27.3409362 Z"></path></g></svg>

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="38"
        height="38"
        viewBox="0 0 38 38"
        marginTop="-1rem"
        aria-hidden="true"
        focusable="false"
      >
        <g id="send-message" transform="translate(-384 -15.195)">
          <circle
            id="Ellipse_46"
            data-name="Ellipse 46"
            cx="19"
            cy="19"
            r="19"
            transform="translate(384 15.195)"
            fill={
              this.props.config.designDetails.sendIconColor !== undefined ||
              this.props.config.designDetails.sendIconColor !== ""
                ? this.props.config.designDetails.sendIconColor
                : "#1b145e"
            }
          />
          <g
            id="Group_40"
            data-name="Group 40"
            transform="translate(396.076 25.766)"
          >
            <path
              id="Vector_90"
              data-name="Vector 90"
              d="M1.7,17.223A2.476,2.476,0,0,1-.264,16.23a2.419,2.419,0,0,1-.385-2.147l1.7-5.847L-.649,2.39A2.419,2.419,0,0,1-.264.243,2.476,2.476,0,0,1,1.7-.75a2.429,2.429,0,0,1,1.182.309L14.759,6.09a2.45,2.45,0,0,1,0,4.293L2.884,16.914A2.429,2.429,0,0,1,1.7,17.223ZM1.7.75a.969.969,0,0,0-.767.393.919.919,0,0,0-.144.827L2.614,8.236.791,14.5a.919.919,0,0,0,.144.827.969.969,0,0,0,.767.393.946.946,0,0,0,.459-.123L14.036,9.069a.95.95,0,0,0,0-1.665L2.161.873A.946.946,0,0,0,1.7.75Z"
              fill="#fff"
            />
            <path
              id="Vector_90-2"
              data-name="Vector 90"
              d="M7.651,8.986H1.833a.75.75,0,0,1,0-1.5H7.651a.75.75,0,0,1,0,1.5Z"
              fill="#fff"
            />
          </g>
        </g>
      </svg>
    );
  };

  startConversation = () => {
    
    loadLocalUser()
    let session = undefined
    this.props.landingPageActions.checkAndStartNewConversationCometd(session);
  };

  newConversationStyle = () => {
    return {
      borderColor: this.props.config.designDetails.headerColor,
    };
  };

  newConversationTextStyle = () => {
    return {
      color: this.props.config.designDetails.selectionButtonTextColor,
      fontFamily: this.props.config.designDetails.selectionButtonFont,
      fontSize: this.props.config.designDetails.selectionButtonFontSize + "px",
      background: this.props.config.designDetails.selectionButtonTextBkgColor,
    };
  };
}
export default NewConversation;
